import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section id="pricing" className="py-24 bg-brand-navy text-white px-4 relative overflow-hidden" data-id="element-128">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-129">
        <div className="absolute top-[-10%] right-[-5%] w-[40%] h-[40%] rounded-full bg-brand-orange/10 blur-[100px]" data-id="element-130" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] rounded-full bg-blue-500/10 blur-[100px]" data-id="element-131" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-lg border border-white/10 rounded-3xl p-8 md:p-12 text-center shadow-2xl" data-id="element-133">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-brand-cream" data-id="element-134">
            Recupera la paz en tu hogar hoy mismo.
          </h2>
          <p className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-135">
            Accede a la{' '}
            <span className="font-serif italic text-brand-orange" data-id="element-136">
              Guía de Supervivencia: Padres de Adolescentes
            </span>{' '}
            y domina el Cortafuegos Verbal con un pago único:
          </p>

          <div className="bg-white rounded-2xl p-8 md:p-10 max-w-md mx-auto text-brand-navy shadow-xl relative" data-id="element-137">
            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-orange text-white px-4 py-1 rounded-full font-bold text-sm uppercase tracking-wider shadow-md" data-id="element-138">
              Ahorras: 67% OFF
            </div>

            <div className="space-y-2 mb-8" data-id="element-139">
              <p className="text-gray-500 font-medium text-lg" data-id="element-140">
                Precio regular: <span className="line-through" data-id="element-141">$44.900</span>
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-142">
                <span className="text-gray-500 font-medium text-xl" data-id="element-143">Hoy:</span>
                <span className="text-5xl font-bold text-brand-orange tracking-tight" data-id="element-144">
                  $14.900
                </span>
              </div>
              <p className="text-sm text-gray-400 font-medium uppercase tracking-wider" data-id="element-145">
                (pago único)
              </p>
            </div>

            <a href="https://metodocapacitarte.com/cart/50193010950501:1" className="w-full block" data-id="element-146">
  <motion.button whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="w-full bg-brand-orange hover:bg-orange-600 text-white font-bold text-lg py-4 px-6 rounded-xl shadow-lg" data-id="element-147">
    ¡QUIERO RECUPERAR LA CALMA EN CASA!
  </motion.button>
</a>
            <p className="text-sm text-gray-500 mt-4 italic" data-id="element-148">
              Acceso inmediato tras la compra. Tu relación con tu hijo lo vale.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}